var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-wrap",style:({'padding': _vm.padding})},[_c('img',{attrs:{"src":require("@/static/images/empty.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.emptyText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }